import { useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function BuildingVerification() {
  const [building_id, setBuildingID] = useState("");
  const [remarks, setRemarks] = useState("");
  const [remarksdate, setRemarksDate] = useState("");

  const saveService = async (e) => {
    e.preventDefault();

    const errors = [];

    if (!building_id.trim()) errors.push("Building ID");
    if (!remarks.trim()) errors.push("ULB Building ID");
    if (!remarksdate) errors.push("ULB Correction Date");

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        //title: "Validation",
        text: `${errors.join(", ")} is required.`,
      });
      return;
    }

    const data = {
      building_id,
      remarks,
      remarksdate,
    };

    try {
      const response = await api.post("/Building/SaveRemarks", data);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      // Clear Form
      setBuildingID("");
      setRemarks("");
      setRemarksDate("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          error.response?.data ||
          "Something went wrong",
      });
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">Building Verification</h5>
      </div>

      <div className="card-body">
        <form onSubmit={saveService}>
          <div className="row">
            <div className="col-md-3 mb-3">
              <label className="form-label">Building ID</label>
              <input
                type="text"
                className="form-control"
                value={building_id}
                onChange={(e) => setBuildingID(e.target.value)}
              />
            </div>
           
            <div className="col-md-6 mb-3">
              <label className="form-label">ULB Building ID</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label className="form-label">ULB Correction Date</label>
              <input
                type="date"
                className="form-control"
                value={remarksdate}
                onChange={(e) => setRemarksDate(e.target.value)}
              />
            </div>

            <div className="col-md-12 text-center mt-3">
              <button type="submit" className="btn btn-success px-4">
                Save Correction
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BuildingVerification;
